import { Col, Row } from 'react-styled-flexboxgrid';

import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Presentation = styled.div`
  width: 80vw;
  max-width: 1050px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${breakpoint('xs', 'sm')`
    width: 100vw;
  `}
`;

const SafariFixContainer = styled.div`
  display: block;
  flex-direction: column;
  flex: 0;
  margin-right: calc(4rem + 36px);

  ${breakpoint('sm')`
    display: flex;
    flex: 1;
  `}

  ${breakpoint('md')`
    margin-right: calc(6.5rem + 36px);
  `}
`;

const HeaderRow = styled(Row)<{ isTransparent?: boolean }>`
  margin-bottom: 1rem;
  margin-right: 2rem;
  height: ${(props) => (!props.isTransparent ? '80px' : '6rem')};
  background: ${theme('colors.white')};

  ${breakpoint('xs')`
    margin-right: 1rem;
  `}
  ${breakpoint('md')`
    margin-right: 2rem;
  `}
  ${breakpoint('lg')`
    margin-right: 4rem;
  `}
`;

const FooterRow = styled(Row)`
  display: block;
  flex: 0;
  font-size: 12px;
  margin: 1rem;
  margin-top: 0;
  margin-right: calc(4rem + 36px);

  ${breakpoint('sm')`
    display: flex;
    flex: 1;
    align-items: flex-end;
  `}

  ${breakpoint('md')`
    margin-right: calc(6.5rem + 36px);
  `}
`;

const MainRow = styled(Row)`
  ${breakpoint('xs', 'sm')`
    flex: 1;
  `}
`;

const RowTitle = styled.span`
  color: ${theme('colors.titleGray')};
  margin-bottom: 1rem;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.3125px;
  text-transform: uppercase;
`;

const NavCol = styled(Col)`
  margin: 0;
  padding: 0;
  padding-left: 2rem;

  ${breakpoint('sm')`
    padding-left: 0;
  `}

  ${breakpoint('md')`
    padding-left: 2rem;
  `}
`;

const NavRow = styled(Row)`
  text-align: right;
  margin: 10px;
  font-weight: bold;
`;

const SocialNavRow = styled(NavRow)`
  a {
    color: ${theme('colors.blue')};
  }

  a:hover {
    color: ${theme('colors.orange')};
  }
`;

const StyledSpan = styled.span`
  color: ${theme('colors.blue')};
`;

const CloseButton = styled.button`
  outline: none;
  background: transparent;
  border: none;
  color: ${theme('colors.blue')};
  margin-left: 2rem;
  -webkit-tap-highlight-color: ${theme('colors.orange')};
  cursor: pointer;
  transition: all 0.5s;

  :hover,
  :focus {
    outline: none;
    color: ${theme('colors.orange')};
  }
`;

const Scroll = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Divider = styled('hr')`
  border: none;
  height: 1px;
  margin: 1rem 0;
  flex-shrink: 0;
  background-color: ${theme('colors.black')};
`;
const Spacer = styled.div`
  display: inline-block;
  padding: 0 0.7rem 0 0.7rem;
`;

const Copyright = styled.div`
  padding: 2rem 0 1rem;
  margin-left: 1rem;
  text-align: left;

  ${breakpoint('sm')`
    text-align: right;
  `}
`;

const Order = styled.div`
  display: block;
  width: 100%;
  ${breakpoint('sm')`
    display: flex;
    & > div:first-child {
      order: 1;
    }
    & > div:last-child {
      order: 0;
    }
  `}
`;

export {
  Presentation,
  SafariFixContainer,
  HeaderRow,
  MainRow,
  RowTitle,
  FooterRow,
  NavRow,
  NavCol,
  SocialNavRow,
  CloseButton,
  StyledSpan,
  Scroll,
  Divider,
  Spacer,
  Copyright,
  Order,
};
